import {UserIcon} from "@pg-design/icons-module";
import {kmAppLink} from "@pg-mono/km-routes";
import {noop} from "@pg-mono/nodash";

import {UserIconPopover} from "../components/UserIconPopover";
import {INavMiddleElement, INavRightElement} from "../Navigation";
import {getFullKMLink} from "../utils/get_full_km_link";
import {useUserPopover} from "./use_user_popover";

export type UseNavigationUserElementsParams = {
    kmUrl: string;
    rpUrl?: string;
    onLogin: (e: React.MouseEvent<HTMLElement>) => void;
    onLogout: (e: React.MouseEvent<HTMLElement>) => void;
    isAuthenticated: boolean;
    isMobile: boolean;
    allowPopoverActivation: boolean;
};

export const useNavigationUserElements = (
    params: UseNavigationUserElementsParams
): {
    navRightElements: INavRightElement[];
    navMobileMiddleElements: INavMiddleElement[];
} => {
    const {kmUrl, onLogin, onLogout, isAuthenticated, isMobile, allowPopoverActivation} = params;

    const {isPopoverActive, onPopoverClose, onHoverUserIcon} = useUserPopover();

    const authenticatedUserNavigationField = {
        title: "Twoje Konto",
        icon: <UserIcon size={isMobile ? "2" : "2.5"} />,
        url: getFullKMLink(kmUrl, kmAppLink.site.offers.appliedWithParams),
        subElements: [
            {
                title: "Moje zapytania",
                url: getFullKMLink(kmUrl, kmAppLink.site.offers.appliedWithParams),
                target: "_blank"
            },
            {
                title: "Ustawienia konta",
                url: getFullKMLink(kmUrl, kmAppLink.site.user.baseWithParams),
                target: "_blank"
            },
            {
                title: "Wyloguj",
                onClick: onLogout
            }
        ]
    };

    const unauthenticatedUserNavigationField = {
        title: "Twoje Konto",
        rel: "nofollow",
        icon: <UserIconPopover isPopoverActive={isPopoverActive} onPopoverClose={onPopoverClose} />,
        onClick: onLogin,
        onHover: allowPopoverActivation ? onHoverUserIcon : noop
    };

    return {
        navRightElements: [isAuthenticated ? authenticatedUserNavigationField : unauthenticatedUserNavigationField],
        navMobileMiddleElements: [
            isAuthenticated
                ? {
                      ...authenticatedUserNavigationField,
                      onClick: () => {
                          if (isMobile) {
                              window.location.href = getFullKMLink(kmUrl, kmAppLink.site.offers.baseWithParams);
                          }
                      }
                  }
                : unauthenticatedUserNavigationField
        ]
    };
};
